import {
  ARTICLE_CODE_COLUMN_ID,
  ARTICLE_CODE_COLUMN_WIDTH,
  ATTRIBUTE_TYPE_ESSENTIAL,
  SEARCHABLE_CONTENT_COLUMN_ID,
  SYSTEMS_COLUMN_FILTER_FUNCTION,
  SYSTEMS_COLUMN_ID,
} from "../common/constants"
import { calculateColumnWidth, fillAttributeUnitAndFractionValues, fillColumnPropsFromAttributes } from "./utils"

const createTableBodyData = (articles) => {
  return articles.map(
    ({
      mainImageUrl,
      articleCode,
      state,
      attributeValues,
      tenderTextId,
      zipCadDrawingsLink,
      zipPhotosDrawingsLink,
      availableZipOptionsFormData,
      systems,
      accessories,
    }) => {
      //change value to be unitless if the unit is in the column or
      //add decimal and fraction fields if the value is in fractions
      const articleAttributeMap = fillAttributeUnitAndFractionValues(attributeValues)

      const article = {
        articleCode,
        mainImageUrl,
        state,
        tenderTextId,
        zipCadDrawingsLink,
        zipPhotosDrawingsLink,
        availableZipOptionsFormData,
        [SEARCHABLE_CONTENT_COLUMN_ID]: "",
        systems,
        accessories,
        ...articleAttributeMap,
      }

      //table is filtered by the cell contents only
      //replacement information is not in an actual cell
      //so we make a cell with additional content and will not display it in the table
      //but its content is searchable
      if (state) {
        if (state.replacedBy) {
          article[SEARCHABLE_CONTENT_COLUMN_ID] += ` ${state.replacedBy}`
        }
        if (state.replacementFor) {
          article[SEARCHABLE_CONTENT_COLUMN_ID] += ` ${state.replacementFor}`
        }
      }

      return article
    }
  )
}

const createTableColumns = ({ articles, attributes }, articleCodeLabel) => {
  const allColumnProperties = fillColumnPropsFromAttributes(attributes, articles)

  const columns = attributes.map(({ attributeId, name, type }) => {
    const singleColumnProperties = allColumnProperties[attributeId]
    const { attributeUnits, values, contents } = singleColumnProperties

    //column has unit only if all the values have the same unit,
    //otherwise keep the unit in the cell
    const unitArr = Array.from(new Set(attributeUnits))
    const unit = unitArr.length === 1 ? unitArr[0] : null

    const hasFraction = unit === '"'
    const width = calculateColumnWidth(contents, unit)
    const hasSameValueInColumn = Array.from(new Set(values)).length === 1

    return {
      Header: name,
      accessor: attributeId,
      displayType: hasFraction ? "fraction" : unit ? "unit" : "alphanumeric",
      sortType: hasFraction ? "basic" : "alphanumeric",
      unit,
      minWidth: width,
      width,
      sortDescFirst: true,
      disableSortBy: hasSameValueInColumn,
      type,
    }
  })

  //this column is used to store searchable data
  //that would not be shown in a column
  //e.g replacedBy, replacementFor, fraction values
  columns.push({
    accessor: SEARCHABLE_CONTENT_COLUMN_ID,
    width: 0,
    minWidth: 0,
  })

  //this column is used to story valid for systems data
  //that would not be shown in an actual column
  //but would be used to filter by
  columns.push({
    accessor: SYSTEMS_COLUMN_ID,
    width: 0,
    minWidth: 0,
    disableGlobalFilter: true,
    filter: SYSTEMS_COLUMN_FILTER_FUNCTION,
  })

  columns.unshift({
    Header: articleCodeLabel,
    accessor: ARTICLE_CODE_COLUMN_ID,
    width: ARTICLE_CODE_COLUMN_WIDTH,
    sortDescFirst: true,
    type: ATTRIBUTE_TYPE_ESSENTIAL,
    disableSortBy: articles.length === 1,
  })

  return columns
}

const prepareDataForTableRender = (rawProductArticles, articleCodeLabel) => {
  const articles = rawProductArticles.articlesList.slice()
  const attributes = rawProductArticles.attributesList.slice()

  const columns = createTableColumns({ articles, attributes }, articleCodeLabel)
  const data = createTableBodyData(articles)

  //should return columns and data objects to
  //fit react-table structure
  return {
    data,
    columns,
  }
}

export default prepareDataForTableRender
